import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactHtmlParser from '@orrisroot/react-html-parser';
import styles from './Banner.module.scss';

const Banner = (props) => {
  const { linkRef, icon, title, description } = props;
  const [alertClass, setAlertClass] = useState('show');

  const navigate = useNavigate();

  const handleCTA = (e) => {
    e.preventDefault();
    setAlertClass('collapse');
    navigate(linkRef);
  };

  return (
    <div onClick={handleCTA} aria-hidden="true" className={`alert row bg-orange text-white fs-5 fw-bold mx-1 alert-dismissible fade ${alertClass}`} role="button">
      <div className="position-absolute top-20 start-0">
        <img className="bi flex-shrink-0 me-2" src={icon} alt={icon} height="40px" width="40px" />
      </div>
      <div className="px-4 mx-4">
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{ReactHtmlParser(description)}</div>
      </div>
    </div>
  );
};

export default Banner;
